function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function () {
  'use strict';

  angular.module('wsLrs.services').factory("Resource", ['$q', '$rootScope', 'Api', '$http', 'Utils', function ($q, $rootScope, Api, $http, Utils) {
    return function Resource(apiUrl, skipTenantPrefix, sharePath) {
      if (apiUrl.lastIndexOf("/") !== apiUrl.length - 1) {
        apiUrl += "/";
      }
      var resource = {
        __apiUrl: function __apiUrl() {
          return Api.url(apiUrl, skipTenantPrefix, sharePath);
        },
        save: function save(entity, cfg) {
          if (entity.id) {
            return $http.put(this.__apiUrl() + entity.id, entity, cfg).then(function success() {
              return entity;
            });
          } else {
            return $http.post(this.__apiUrl(), entity).then(function success(response) {
              entity.id = Utils.getIdFromCreatedResponse(response);
              return entity;
            });
          }
        },
        get: function get(id, cfg) {
          return $http.get(this.__apiUrl() + (id || ""), cfg).then(function success(response) {
            return response.data;
          }, function error(response) {
            return response.status === 404 ? null : $q.reject(response);
          });
        },
        getUrl: function getUrl(idOrParams, params) {
          var firstArgIsParams = _typeof(idOrParams) === "object";
          var id = firstArgIsParams ? "" : idOrParams;
          params = firstArgIsParams ? idOrParams : params;
          id = id || "";
          var url = this.__apiUrl() + id;
          if (!params) {
            return url;
          } else {
            return Utils.appendParams(url, params);
          }
        },
        list: function list(params, cfg) {
          cfg = cfg || {
            params: {}
          };
          cfg.params = _.extend(cfg.params, params);
          return $http.get(this.__apiUrl(), cfg).then(function success(response) {
            return response.data;
          });
        },
        getAll: function getAll(cfg) {
          cfg = cfg || {};
          var self = this,
            all = [],
            limit = cfg.limit || 500,
            // Avoid fetching and loading too much on the client
            maxLimit = cfg.maxLimit || 2000;
          var maxPages = maxLimit / limit;
          function fetch(pageNumber) {
            pageNumber = pageNumber || 0;
            var fetchCfg = $.extend(cfg, {
              _offset: pageNumber * limit,
              _limit: limit
            });
            return self.list(fetchCfg).then(function (listing) {
              Array.prototype.push.apply(all, listing.results);
              var limitReached = all.length >= Math.min(listing.count, maxLimit),
                maxPagesReached = pageNumber >= maxPages;
              if (!limitReached && !maxPagesReached) {
                return fetch(pageNumber + 1);
              } else {
                var deferred = $q.defer();
                deferred.resolve(all);
                return deferred.promise;
              }
            });
          }
          return fetch();
        },
        multiGet: function multiGet(ids, cfg) {
          cfg = cfg || {
            params: {}
          };
          cfg.params = _.extend(cfg.params, {
            ids: null
          });
          cfg.params.ids = ids;

          // If no IDs given, return empty results
          if (_.isEmpty(cfg.params.ids) && _.isEmpty(cfg.params.customIds)) {
            var future = $q.defer();
            future.resolve({
              count: 0,
              results: []
            });
            return future.promise;
          }
          return $http.get(this.__apiUrl() + "multi", cfg).then(function success(response) {
            return response.data;
          }, function error(response) {
            return response.status === 404 ? null : $q.reject(response);
          });
        },
        multiSave: function multiSave(entities, cfg) {
          return $http.put(this.__apiUrl() + "multi", entities, cfg).then(function success() {
            return entities;
          }, function error(response) {
            return $q.reject(response);
          });
        },
        count: function count(cfg) {
          return this.list({
            _limit: 0
          }, cfg).then(function success(response) {
            return response.count;
          }, function error(response) {
            return response.status === 404 ? null : $q.reject(response);
          });
        },
        remove: function remove(id, cfg) {
          return $http['delete'](this.__apiUrl() + id, cfg).then(function success(response) {
            return response.data;
          }, function error(response) {
            return response.status === 404 ? null : $q.reject(response);
          });
        },
        find: function find(params, cfg) {
          return this.list(params, cfg).then(function success(results) {
            return results.count === 0 ? null : results.count === 1 ? results.results[0] : $q.reject("Found more than one record matching: " + JSON.stringify(params));
          });
        }
      };
      return resource;
    };
  }]);
})();
